export default "__VITE_ASSET__Xs775mL0__"